import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { EPageName } from 'Common/types';
import { useStatistic } from 'Common/hooks';
import useRouter from 'Router/hooks/useRouter/useRouter';
import { PHENOTYPE_CATALOGUE_LABEL } from 'PhenotypeCatalogueView/consts';
import Page from './Page';
export const PAGE_NAME = EPageName.PhenotypeCatalogue;
const PageContainer = () => {
    const { getLocation, } = useRouter();
    const { pathname } = getLocation();
    const referrerState = useMemo(() => ({
        referrerURI: pathname,
        referrerData: {
            name: PHENOTYPE_CATALOGUE_LABEL,
        },
    }), [pathname]);
    useStatistic();
    return (_jsx(Page, { referrerState: referrerState, pageName: PAGE_NAME }, void 0));
};
export default PageContainer;
